import MainMenu from '@/Components/Menus/Main/MainMenu.jsx';
import * as React from 'react';
import {memo} from 'react';

const AuthenticatedMenu = () => {
    const items = [
        {
            id: 'projects',
            text: 'Accueil',
            route: route('projects.list'),
            variant: 'plain',
        },
        {
            id: 'profile',
            text: 'Compte',
            route: route('profile.edit'),
            variant: 'plain',
        },
        {
            id: 'logout',
            text: 'Se déconnecter',
            route: route('logout'),
            method: 'get',
            variant: 'contained',
            color: 'neutral',
            preserveState: false,
            external: true, // Force une navigation native (non-Inertia)
        },
    ];

    return <MainMenu menuItems={items} />;
};
export default memo(AuthenticatedMenu);
